import { render, staticRenderFns } from "./new-transaction.vue?vue&type=template&id=ea29c576&"
import script from "./new-transaction.vue?vue&type=script&lang=js&"
export * from "./new-transaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports